module.exports = __webpack_public_path__ + "img/_54A6697_t.dd67f638.jpg";